module.exports = "assets/8b1566421f42faa5fb64788b04b4008e.glb";